import { render, staticRenderFns } from "./routerUser.vue?vue&type=template&id=2de00b01&"
import script from "./routerUser.vue?vue&type=script&lang=js&"
export * from "./routerUser.vue?vue&type=script&lang=js&"
import style0 from "./routerUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports